/* LUXX COSMETIC · koleksiyon ve arama sayfası (Shopify teması; demo koleksiyon.js'in karşılığı)
   Filtre, sıralama ve sayfa Shopify'ın kendi parametreleriyle URL'de durur (filter.p.vendor, filter.v.price.gte, sort_by, page).
   Sayfa JS olmadan da çalışır (düz GET formu ve bağlantılar); bu betik formu ve bağlantıları Section Rendering API ile
   sayfa yenilemeden uygular, geri tuşu çalışır. Açık/kapalı gruplar, "Show more" ve odak yeniden çizimde korunur.
   Mobilde filtre sütunu alttan açılan panele taşınır. Ortak API: window.LUXX (luxx-site.js). */
(() => {
  'use strict';
  const X = window.LUXX;
  if (!X) return;
  const { $, $$, norm } = X;
  const T = X.t;   // çeviri (window.LUXX_T, locales "js.*")
  const kok = $('[data-kol-bolum]');
  if (!kok) return;
  const BOLUM = kok.dataset.kolBolum;
  const MOBIL = matchMedia('(max-width: 1099px)');
  const UI = { kapali: {}, fazla: {}, markaAra: '' };

  /* ---------- Görünüm durumu: kapalı gruplar, "Show more", marka araması (yeniden çizimden sonra geri gelir) ---------- */
  function markaSuz(giris) {
    const ul = giris.closest('.f-ic').querySelector('.f-liste'); if (!ul) return;
    const q = norm(giris.value);
    let gorunen = 0;
    $$('li[data-isim]', ul).forEach(li => { const g = !q || norm(li.dataset.isim).includes(q); li.classList.toggle('ara-disi', !g); if (g) gorunen++; });
    const id = ul.dataset.liste;
    ul.classList.toggle('acik', !!q || !!UI.fazla[id]);
    const daha = $('.f-daha-satir', ul); if (daha) daha.hidden = !!q;
    const yok = $('.f-yok', ul);
    if (yok) { yok.hidden = !q || gorunen > 0; yok.textContent = T('ortak.no_brand_matches', { q: giris.value }); }
  }
  function uiUygula(kap = kok) {
    // varsayılan: yalnız fiyat, Format ve seçimi olan bloklar açık (Liquid); kullanıcının açtığı/kapattığı blok yeniden çizimde korunur
    $$('details[data-grup]', kap).forEach(d => { const k = UI.kapali[d.dataset.grup]; if (k !== undefined) d.open = !k; });
    $$('[data-daha]', kap).forEach(b => {
      const acik = !!UI.fazla[b.dataset.daha], ul = b.closest('.f-liste');
      ul.classList.toggle('acik', acik);
      b.setAttribute('aria-expanded', acik);
      b.textContent = acik ? T('ortak.show_less') : b.dataset.ac;
    });
    const ara = $('[data-marka-ara]', kap);
    if (ara) { ara.value = UI.markaAra; markaSuz(ara); }
  }

  /* ---------- Yeniden çizimde odak ve imleç korunur (data-odak anahtarıyla) ---------- */
  function odakKoru(ciz) {
    const a = document.activeElement, anahtar = a && kok.contains(a) ? a.dataset.odak : null;
    const imlec = anahtar && a.type === 'search' && a.selectionStart != null ? a.selectionStart : null;
    ciz();
    if (!anahtar) return;
    const el = $$('[data-odak]', kok).find(e => e.dataset.odak === anahtar);
    if (el) { el.focus({ preventScroll: true }); if (imlec !== null) try { el.setSelectionRange(imlec, imlec); } catch { /* yok */ } }
  }

  /* ---------- Form → URL (boş alanlar ve sınırdaki fiyat düşer) ---------- */
  const form = () => $('#kolFiltreForm');
  function formUrl() {
    const f = form(); if (!f) return location.href;
    const p = new URLSearchParams();
    for (const [k, v] of new FormData(f)) if (v !== '') p.append(k, v);
    const fk = $('[data-fiyat]', f);
    if (fk) {
      const [k0, k1] = $$('[data-fiyat-kutu]', fk), a = +fk.dataset.alt, b = +fk.dataset.ust;
      if (+k0.value <= a) p.delete(k0.name);
      if (+k1.value >= b) p.delete(k1.name);
    }
    p.delete('page');
    const yol = new URL(f.getAttribute('action') || location.pathname, location.origin).pathname;
    return yol + (p.toString() ? '?' + p.toString() : '');
  }

  /* ---------- Section Rendering API: yalnız [data-kol-parca] parçaları değişir ---------- */
  let istekNo = 0;
  async function yukle(url, { push = true, kaydir = false } = {}) {
    const no = ++istekNo, u = new URL(url, location.origin);
    const su = new URL(u); su.searchParams.set('section_id', BOLUM);
    kok.classList.add('yukleniyor');
    let html;
    try { const r = await fetch(su, { headers: { Accept: 'text/html' } }); if (!r.ok) throw new Error(r.status); html = await r.text(); }
    catch { location.href = u.href; return; }
    if (no !== istekNo) return;   // bu arada yeni bir seçim yapıldı
    const yeni = new DOMParser().parseFromString(html, 'text/html');
    // düzen değiştiyse (ör. boş durum) tam sayfa
    if (!!$('#kolFiltreForm', yeni) !== !!form() || !$('[data-kol-parca="icerik"]', yeni)) { location.href = u.href; return; }
    odakKoru(() => {
      $$('[data-kol-parca]', yeni).forEach(p => { const eski = $(`[data-kol-parca="${p.dataset.kolParca}"]`, kok); if (eski) eski.innerHTML = p.innerHTML; });
    });
    kok.classList.remove('yukleniyor');
    if (push) history.pushState({ luxxKol: true }, '', u.pathname + u.search);
    sonrasi();
    if (kaydir) {
      const arac = $('#kolArac');
      if (arac) { const y = arac.getBoundingClientRect().top + scrollY - hdYuk() - 16; if (scrollY > y) scrollTo({ top: y }); }
    }
  }
  addEventListener('popstate', () => yukle(location.href, { push: false }));

  /* ---------- Olaylar ---------- */
  let gonderZaman;
  // filtre / sıralama değişince sonuçların başına çıkılır (aşağıdayken liste kısalınca sayfa footer'da kalmasın)
  const gonder = (gecikme = 0) => { clearTimeout(gonderZaman); gonderZaman = setTimeout(() => yukle(formUrl(), { kaydir: true }), gecikme); };
  kok.addEventListener('change', e => {
    const t = e.target;
    if (t.matches('.f-kutu')) { gonder(); return; }
    if (t.id === 'siraSec') { gonder(); return; }
    if (t.name === 'siraM') {
      const s = $('#siraSec'); if (s) s.value = t.value;
      X.cekmeceKapat(); gonder(); return;
    }
    if (t.matches('[data-fiyat-uc], [data-fiyat-kutu]')) {
      const kutu = t.closest('[data-fiyat]'), a = +kutu.dataset.alt, b = +kutu.dataset.ust;
      const kaynak = $$(t.matches('[data-fiyat-uc]') ? '[data-fiyat-uc]' : '[data-fiyat-kutu]', kutu).map(i => Math.min(b, Math.max(a, Math.round(+i.value || 0))));
      let [lo, hi] = kaynak; if (lo > hi) [lo, hi] = [hi, lo];
      const [k0, k1] = $$('[data-fiyat-kutu]', kutu); k0.value = lo; k1.value = hi;
      gonder(250);
    }
  });
  kok.addEventListener('input', e => {
    const t = e.target;
    if (t.matches('[data-marka-ara]')) { UI.markaAra = t.value; markaSuz(t); yapiskanAyarla(); return; }
    if (t.matches('[data-fiyat-uc]')) {
      // sürüklerken yalnız görünüm: uçlar birbirini geçmez, kutular ve dolu çizgi güncellenir
      const kutu = t.closest('[data-fiyat]'), [u0, u1] = $$('[data-fiyat-uc]', kutu), a = +kutu.dataset.alt, b = +kutu.dataset.ust;
      if (+u0.value > +u1.value) { if (t === u0) u0.value = u1.value; else u1.value = u0.value; }
      const fark = b - a || 1;
      kutu.style.setProperty('--a', (u0.value - a) / fark); kutu.style.setProperty('--b', (u1.value - a) / fark);
      const [k0, k1] = $$('[data-fiyat-kutu]', kutu); k0.value = u0.value; k1.value = u1.value;
    }
  });
  kok.addEventListener('submit', e => { if (e.target.id === 'kolFiltreForm') { e.preventDefault(); gonder(); } });
  kok.addEventListener('keydown', e => { if (e.key === 'Enter' && e.target.matches('[data-marka-ara]')) e.preventDefault(); });
  kok.addEventListener('toggle', e => { const g = e.target.closest && e.target.closest('details[data-grup]'); if (g) { UI.kapali[g.dataset.grup] = !g.open; yapiskanAyarla(); } }, true);
  kok.addEventListener('click', e => {
    const link = e.target.closest('a[data-kol-link]');
    if (link && !e.metaKey && !e.ctrlKey && !e.shiftKey && e.button === 0) {
      e.preventDefault();
      yukle(link.href, { kaydir: link.hasAttribute('data-kaydir') });
      return;
    }
    const daha = e.target.closest('[data-daha]');
    if (daha) {
      const id = daha.dataset.daha;
      UI.fazla[id] = !UI.fazla[id];
      uiUygula(daha.closest('.f-liste').parentNode);
      yapiskanAyarla();
      return;
    }
    const panel = e.target.closest('[data-alt-panel]');
    if (panel) { X.cekmeceAc($('#' + panel.dataset.altPanel), panel); return; }
    if (e.target.closest('[data-alt-kapat]')) X.cekmeceKapat();
  });

  /* ---------- Mobil: filtre sütunu alttan açılan panele taşınır ---------- */
  function yerlestir() {
    const ic = $('#kolFiltreIc'), govde = $('#filtreGovde'), yan = $('#kolFiltre');
    if (!ic || !govde || !yan) return;
    const hedef = MOBIL.matches ? govde : yan;
    if (ic.parentNode !== hedef) hedef.appendChild(ic);
  }
  MOBIL.addEventListener('change', () => { X.cekmeceKapat(false); yerlestir(); yapiskanAyarla(); });

  /* ---------- Yapışkan kenar sütunu (panelin kendi kaydırma çubuğu yok) ----------
     Ekrana sığarsa header'ın altında durur. Sığmazsa sayfayla akar: aşağı kayarken alt ucu ekranın altına,
     yukarı kayarken üst ucu header'ın altına gelince durur. Sticky "top" değeri kaydırma miktarı kadar kaydırılıp sınırlanır. */
  const hd = $('#hd');
  const hdYuk = () => (hd ? Math.max(0, hd.offsetHeight + (parseFloat(getComputedStyle(hd).top) || 0)) : 0);
  let fUst = null, sonY = scrollY, kare = 0;
  function yapiskanAyarla() {
    const f = $('#kolFiltre'); if (!f) return;
    f.classList.toggle('yapiskan', !MOBIL.matches);
    if (MOBIL.matches) { f.style.removeProperty('--f-ust'); fUst = null; return; }
    const ust = hdYuk() + 16, alt = innerHeight - f.offsetHeight - 16;
    if (alt >= ust) { fUst = ust; } else { fUst = Math.min(ust, Math.max(alt, fUst == null ? ust : fUst - (scrollY - sonY))); }
    sonY = scrollY;
    f.style.setProperty('--f-ust', fUst + 'px');
  }
  addEventListener('scroll', () => { if (!kare) kare = requestAnimationFrame(() => { kare = 0; yapiskanAyarla(); }); }, { passive: true });
  if ('ResizeObserver' in window) { const f0 = $('#kolFiltre'); if (f0) new ResizeObserver(() => yapiskanAyarla()).observe(f0); }
  function ustAyarla() { document.documentElement.style.setProperty('--hd-yuk', hdYuk() + 'px'); yapiskanAyarla(); }
  if (hd && 'ResizeObserver' in window) new ResizeObserver(ustAyarla).observe(hd);
  addEventListener('resize', ustAyarla);

  /* ---------- Arama: adı eşleşen koleksiyonlar (Shopify predictive search) ---------- */
  let kategoriIstek = null;
  function aramaKategori() {
    const kutu = $('[data-arama-kategori]', kok); if (!kutu) return;
    const q = kutu.dataset.q; if (!q || q.length < 2) return;
    if (!kategoriIstek) {
      kategoriIstek = fetch(`${X.A.routes.predictive}.json?q=${encodeURIComponent(q)}&resources%5Btype%5D=collection&resources%5Blimit%5D=10`)
        .then(r => (r.ok ? r.json() : null)).then(j => (j && j.resources && j.resources.results && j.resources.results.collections) || []).catch(() => []);
    }
    kategoriIstek.then(l => {
      const ul = $('.f-liste', kutu); if (!ul || !l.length) return;
      ul.innerHTML = l.map(c => `<li><a class="f-kat" href="${X.kac(c.url)}"><span class="f-isim">${X.kac(c.title)}</span></a></li>`).join('');
      kutu.hidden = false;
      yapiskanAyarla();
    });
  }

  /* ---------- Her çizimden sonra ---------- */
  function sonrasi() {
    yerlestir();
    uiUygula();
    aramaKategori();
    yapiskanAyarla();
  }
  sonrasi();
  ustAyarla();

  /* ---------- İndirim kodu bandı (koleksiyonların altında; süresi geçince kendiliğinden kalkar) ---------- */
  const bant = $('#kolKupon');
  if (bant) {
    const kupon = X.kuponHTML({ git: bant.dataset.kuponGit !== '0' });
    if (kupon) { $('#kolKuponIc').innerHTML = `<div class="kupon-serit">${kupon}</div>`; bant.hidden = false; }
  }
})();
